export default function animate () {
  if (window.$.fn.waypoint) {
    window.$('.animated').css('opacity', '0')
    window.$('.animated').waypoint(function () {
      window.$(this).addClass('fadeInUp')
      window.$('.animated.fadeInUp').css({
        opacity: 1
      })
    }, {
      offset: '90%'
    })
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/animation.js